import config from '../config';

const VERSION_STORAGE_KEY = 'fermi_app_version';

export async function checkForUpdates(): Promise<boolean> {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
    });

    if (!response.ok) return false;

    const data = await response.json();
    const remoteVersion = data.version;
    const localVersion = config.VERSAO;
    const cachedVersion = localStorage.getItem(VERSION_STORAGE_KEY);

    // Se a versão remota é diferente da local OU da cached, precisa atualizar
    if (remoteVersion !== localVersion || (cachedVersion && cachedVersion !== remoteVersion)) {
      localStorage.setItem(VERSION_STORAGE_KEY, remoteVersion);
      return true;
    }

    // Salva versão atual no storage
    localStorage.setItem(VERSION_STORAGE_KEY, localVersion);
    return false;
  } catch (error) {
    console.warn('Verificação de versão falhou:', error);
    return false;
  }
}

export function forceReload(): void {
  // Limpa caches do service worker se existir
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }

  // Limpa a versão armazenada para forçar nova verificação
  localStorage.removeItem(VERSION_STORAGE_KEY);

  // Force reload sem cache
  window.location.reload();
}
